module.exports = __webpack_public_path__ + "static/media/MarkAsUnread.59364dbc.svg";